export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 7.87,
        "transcript": "There were teachers and preachers, and tua-i yugyagluteng. Yugyagluteng. Kipusviliurtet-llu amllellruut.",
        "translation": "There were teachers and preachers, and a lot of people. There were a lot of people. There were also a lot of storekeepers."
    },
    "2": {
        "startTime": 7.87,
        "endTime": 9.99,
        "transcript": "Kass'alillruuq.",
        "translation": "There were a lot of Caucasians."
    },
    "3": {
        "startTime": 11.065,
        "endTime": 14.435,
        "transcript": "Yugnek tua-i yungqeng'e'rmi yugyagluni.",
        "translation": "Though it was populated by Yupiit, there were a lot of people."
    },
    "4": {
        "startTime": 14.435,
        "endTime": 15.665,
        "transcript": "What's going on?",
        "translation": "What's going on?"
    },
    "5": {
        "startTime": 15.665,
        "endTime": 18.595,
        "transcript": "Buzzing paper from the wind.",
        "translation": "Buzzing paper from the wind."
    },
    "6": {
        "startTime": 19.145,
        "endTime": 22.105,
        "transcript": "Okay, anytime.",
        "translation": "Okay, anytime."
    },
    "7": {
        "startTime": 22.758,
        "endTime": 23.448,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "8": {
        "startTime": 26.493,
        "endTime": 37.893,
        "transcript": "Ak'a imumi wani maavet nugtarteqarraallerpeni Mamterillermun qaillun murilkellrusiu? Man'a wani nuna qaillun ayuqellrua?",
        "translation": "Long ago when you first moved here to Bethel, what did you observe? What was this land like?"
    },
    "9": {
        "startTime": 39.05,
        "endTime": 45.25,
        "transcript": "Taiqarraallemteńi wiinga ketvut un'a kuigullruuq.",
        "translation": "When we first came, the area toward the water down there was a river."
    },
    "10": {
        "startTime": 46.496,
        "endTime": 51.866,
        "transcript": "Ketvut-llu man'a bank-aq assirlun' tua-i, willows-arluni-llu.",
        "translation": "And toward the water from us, the bank here was good, and had willows."
    },
    "11": {
        "startTime": 51.874,
        "endTime": 55.274,
        "transcript": "Under the bank naanguarnaurtukut.",
        "translation": "We would play under the bank."
    },
    "12": {
        "startTime": 55.616,
        "endTime": 59.446,
        "transcript": "Alingtallruama wii yaaqvanun ayagayuitellruunga.",
        "translation": "Because I was cowardly, I wouldn't go far."
    },
    "13": {
        "startTime": 59.678,
        "endTime": 64.488,
        "transcript": "Tua-i assirluni nuna tua-i yugyagpek'nateng.",
        "translation": "The land was good, and there were not a lot of people."
    },
    "14": {
        "startTime": 65.039,
        "endTime": 66.409,
        "transcript": "Yugpalluuluteng-qaa?",
        "translation": "Were they mostly Yup'ik?"
    },
    "15": {
        "startTime": 66.416,
        "endTime": 71.846,
        "transcript": "Yugpalluuluteng Kass'anek tua-i ilaluteng. Kass'at tua-i amllerrluteng.",
        "translation": "They were mostly Yup'ik with Caucasians among them. There were a lot of Caucasians."
    },
    "16": {
        "startTime": 72.812,
        "endTime": 82.342,
        "transcript": "Elitnaursitet, agayulirtet, kipusviliurtet-llu, makut-llu miners from mining camps and fishing.",
        "translation": "Teachers, priests, and storekeeps, and these miners from mining camps and fishing."
    },
    "17": {
        "startTime": 82.351,
        "endTime": 89.711,
        "transcript": "Tamaani-qaa maani Mamterillermi makunek mud house?",
        "translation": "Back then, [were there] these mud houses here in Bethel?"
    },
    "18": {
        "startTime": 89.727,
        "endTime": 95.677,
        "transcript": "Mud house-amek qasgitangqellruuq, qasgimek mud house.",
        "translation": "There was a mud community house, a mud community house."
    },
    "19": {
        "startTime": 95.682,
        "endTime": 98.332,
        "transcript": "Angluni qasgirpall'er.",
        "translation": "The huge community house was big."
    },
    "20": {
        "startTime": 98.571,
        "endTime": 102.871,
        "transcript": "Elpenek-qaa enenek uitangenratgun...",
        "translation": "From you, right when they started living in houses..."
    },
    "21": {
        "startTime": 102.962,
        "endTime": 107.322,
        "transcript": "Enenek eneluteng, log houses.",
        "translation": "They had houses, log houses."
    },
    "22": {
        "startTime": 107.465,
        "endTime": 117.605,
        "transcript": "Ukut-llu mission-aat kiimeng lumber-aanek eneluteng, ilait-llu cali makut yuut tua-i lumber-aanek eneluteng.",
        "translation": "And these missions were the only ones with lumber houses, and some of these people also had lumber houses."
    },
    "23": {
        "startTime": 117.614,
        "endTime": 122.504,
        "transcript": "Tau͡gken tua-i makut ilait cali log houses. Amllerrluteng.",
        "translation": "However, some of them also had log houses. There were a lot."
    },
    "24": {
        "startTime": 122.558,
        "endTime": 126.658,
        "transcript": "Mud house-amek tanger[pek'nii], tauna tau͡gaam qasgiq.",
        "translation": "[I didn't] see a mud house, except for that community house."
    },
    "25": {
        "startTime": 129.965,
        "endTime": 137.595,
        "transcript": "Yuungnaqengllerpeni tayima tamaani nerangnaqsaraq pingllerpegu",
        "translation": "When you made your own living back then, starting to subsist"
    },
    "26": {
        "startTime": 138.116,
        "endTime": 149.516,
        "transcript": "Tamatumek wani qanrutqerkut qaillun iciw' uitayulriit uitanrilnguut-llu enuqlilluteng (Ii-i.) enuqlitevkenateng-llu.",
        "translation": "Tell us about that, you know, how sedentary people and and active people don't have enough (Yes.) and don't lack things."
    },
    "27": {
        "startTime": 149.523,
        "endTime": 155.583,
        "transcript": "Tua-i-wa imumi ellangellemni wii yuut neqa cumigutellrukiit.",
        "translation": "In my earlies memories long ago, people focused on food."
    },
    "28": {
        "startTime": 155.59,
        "endTime": 158.3,
        "transcript": "Tua-i neqsurnaurtut cumiggluteng.",
        "translation": "They'd persistently fish."
    },
    "29": {
        "startTime": 158.311,
        "endTime": 165.011,
        "transcript": "Cat-llu meluit-llu kinercirluki, qamiqurrit-llu makut kinercirluki",
        "translation": "And they'd dry their roe, and dry their heads."
    },
    "30": {
        "startTime": 165.218,
        "endTime": 170.408,
        "transcript": "Kuvyangqessuilameng taktuarpagnek maa-i mat'um nalliinitun.",
        "translation": "Because they didn't have extremely long drift nets like today."
    },
    "31": {
        "startTime": 170.413,
        "endTime": 175.393,
        "transcript": "Kuvyait nanilameng, cav'urluteng-llu pilaameng.",
        "translation": "Because their drift nets were short, and they'd always row [when traveling]."
    },
    "32": {
        "startTime": 176.084,
        "endTime": 180.934,
        "transcript": "Wiinga-w' tua-i anaggluni yuulriamek tangellrunrilngua.",
        "translation": "I didn't see anyone surpassing that life."
    },
    "33": {
        "startTime": 181.505,
        "endTime": 188.295,
        "transcript": "Tua-i cavluteng kuvyaaqluteng, angyait-llu angevkenateng cav'ssuutnguameng.",
        "translation": "They would row to go drift net, and their boats weren't big because they were meant for rowing."
    },
    "34": {
        "startTime": 188.553,
        "endTime": 190.913,
        "transcript": "Kuvyait-llu takevkenateng.",
        "translation": "And their nets weren't long."
    },
    "35": {
        "startTime": 190.926,
        "endTime": 195.186,
        "transcript": "Tua-i neqet qellekluki pinaurait cakneq.",
        "translation": "They would make great effort to conserve fish."
    },
    "36": {
        "startTime": 195.819,
        "endTime": 203.139,
        "transcript": "Qusuurnek ayagluteng qusuurnek qaluluteng nuvluki iniluki puyurluki-ll'.",
        "translation": "Starting from rainbow smelt, they use dipnets for rainbow smelt, thread them through [grass ropes], hang them, and smoke them."
    },
    "37": {
        "startTime": 203.319,
        "endTime": 208.209,
        "transcript": "Qimugtet neqekluki ellaita-ll' wangkuta-ll' ner'aqluki.",
        "translation": "They were food for dogs, and they'd, we'd eat them too."
    },
    "38": {
        "startTime": 209.811,
        "endTime": 213.671,
        "transcript": "Cat tua-i piqcaarturluki.",
        "translation": "They steadily worked on things."
    },
    "39": {
        "startTime": 214.275,
        "endTime": 222.465,
        "transcript": "Maa-i imumi-llu neqa wani imumi-qaa neqa sagtelallruuq wall'u-qaa qaillun?",
        "translation": "Now, and in the past, was fish strewn about in the past or what?"
    },
    "40": {
        "startTime": 222.477,
        "endTime": 232.377,
        "transcript": "Wani sagtelallrat neqem sagtengellra qaillun enurnariuq-qaa qaillun? Tamatumek cali.",
        "translation": "How they're strew about, with fish getting strewn about, is it somehow getting harder to find? [Please talk about] that too."
    },
    "41": {
        "startTime": 232.384,
        "endTime": 236.444,
        "transcript": "Sagciyuitellruut neqnek murilkeqarraallemni.",
        "translation": "They didn't make a mess fish when I first became observant."
    },
    "42": {
        "startTime": 236.456,
        "endTime": 239.926,
        "transcript": "Cakneq kencikluki auluk'lallruit.",
        "translation": "They cared for them with great reverence."
    },
    "43": {
        "startTime": 239.937,
        "endTime": 245.847,
        "transcript": "Tua-i sagtevkenaki tutmayuunaki-llu neqallret.",
        "translation": "They wouldn't scatter or tread upon food scraps."
    },
    "44": {
        "startTime": 245.857,
        "endTime": 247.827,
        "transcript": "Inerquutekluku.",
        "translation": "They admonished against that."
    },
    "45": {
        "startTime": 247.906,
        "endTime": 254.546,
        "transcript": "Tutmaasaqevkenaki cat, yaqulget-llu cat, tua-i piciatun nertukait.",
        "translation": "They told them not to tread upong things, and [all] kinds of birds, anything they ate."
    },
    "46": {
        "startTime": 254.983,
        "endTime": 258.733,
        "transcript": "Kencikluki cakneq auluktullruit.",
        "translation": "They took care of them with great reverence."
    },
    "47": {
        "startTime": 258.839,
        "endTime": 265.739,
        "transcript": "Neqet-llu tua-i murilkelluki, puyuqumariata-llu qemaggluki.",
        "translation": "And they tended to the fish, and when they'd been smoked, they stored them."
    },
    "48": {
        "startTime": 266.205,
        "endTime": 271.705,
        "transcript": "Qemaggluki cailkami uitavkarpek'naki.",
        "translation": "They stored them, not left them in random places."
    },
    "49": {
        "startTime": 271.714,
        "endTime": 277.584,
        "transcript": "Camek wani kangililallruatgu tamana wani kencikluku neqa pisqelalteng?",
        "translation": "What meaning did they give when telling you to revere fish?"
    },
    "50": {
        "startTime": 278.793,
        "endTime": 284.173,
        "transcript": "Kencikevkenaki-gguq piaqata enurnarituut cat, neqet.",
        "translation": "They say that when they don't revere them, things, fish, get scarce."
    },
    "51": {
        "startTime": 284.94,
        "endTime": 287.61,
        "transcript": "Enurnarituniluki.",
        "translation": "They said they become scarce."
    },
    "52": {
        "startTime": 287.917,
        "endTime": 290.477,
        "transcript": "Tuaten niitetullruunga.",
        "translation": "That's what I used to hear."
    },
    "53": {
        "startTime": 290.622,
        "endTime": 301.062,
        "transcript": "Maa-i-qaa murilkellerpeni maa-i ernemteńi wangkuta tayim' neqallernek tanglalriakut qagaani.",
        "translation": "In your observation of our days now, we see food scraps out there."
    },
    "54": {
        "startTime": 301.071,
        "endTime": 308.511,
        "transcript": "Tua-i-w' maa-i qelkenrirluki arenqiatuq [?pili]vkenaki ayuqengameng.",
        "translation": "It's unfortunate that they're not taking care of them anymore, because they [?don't make them] anymore."
    },
    "55": {
        "startTime": 308.523,
        "endTime": 316.013,
        "transcript": "Kipusvignek akit-llu tekirqellriit pikaunrilata cikiutet amlleriluteng.",
        "translation": "From the stores, and since money that is coming aren't for things, there are now a lot of gifts."
    },
    "56": {
        "startTime": 316.026,
        "endTime": 321.226,
        "transcript": "Wangkuta imum' elliraungramta cikiutmek nallullruukut.",
        "translation": "Back then, though we may have been orphans, we didn't know of gifts."
    },
    "57": {
        "startTime": 321.816,
        "endTime": 328.996,
        "transcript": "Cikiutmek aulukestaunata aanamta aulukeqcaarallruakut elliin calillmikun unatmikun.",
        "translation": "Without having gifts to take care of us, our mother steadily worked to take care of us through her work with her hands."
    },
    "58": {
        "startTime": 330.496,
        "endTime": 336.196,
        "transcript": "Elliraat-mi, elliraat canek alerqualallruitki?",
        "translation": "So, what would they instruct to the orphans?"
    },
    "59": {
        "startTime": 336.316,
        "endTime": 344.246,
        "transcript": "Tua-i-wa elliraat, elliraat yuum, yuut takumcuktullrukait.",
        "translation": "Orphans, a person, people would take pity on orphans."
    },
    "60": {
        "startTime": 344.314,
        "endTime": 349.394,
        "transcript": "Tangrrinarpek'naki ikayualuki, tungelqurrita-ll' ikayualuki.",
        "translation": "Without looking and ignoring, they helped them, and their families helped them."
    },
    "61": {
        "startTime": 349.399,
        "endTime": 351.689,
        "transcript": "Tuaten ayuqellruut.",
        "translation": "That's what they were like."
    },
    "62": {
        "startTime": 351.689,
        "endTime": 360.279,
        "transcript": "Maa-i tua-i yuk cayaaqeciquq neqkaunani, nalluciqaat yuut. Naklekngaitaat.",
        "translation": "Now, a person may be in a situation without food, and peopl won't know them. They won't pity them."
    },
    "63": {
        "startTime": 361.595,
        "endTime": 368.845,
        "transcript": "Eyagyaraq-mi? Eyagyaraq-qaa atulall[ruat]? Murilkellruuten-qaa eyagyaranek piaqata?",
        "translation": "What about abstinence practices? Did [they] practice abstinence? Did you observe when they did abstinence?"
    },
    "64": {
        "startTime": 368.855,
        "endTime": 373.725,
        "transcript": "Yaa. Wii tang eyagyaraq nallukeka.",
        "translation": "Yes. You see, I don't know abstinence practices."
    },
    "65": {
        "startTime": 373.735,
        "endTime": 375.905,
        "transcript": "Eyagyarat wii nalluanka.",
        "translation": "I don't know abstinence practices."
    },
    "66": {
        "startTime": 375.918,
        "endTime": 382.138,
        "transcript": "Aanaka imna eyagyaranek pissiyaallrunrilan nalluanka wii amlleret.",
        "translation": "Since my mother didn't do much abstinence, I don't know many of them."
    },
    "67": {
        "startTime": 382.165,
        "endTime": 387.965,
        "transcript": "Nalluamki-llu piyuilengraan tuaten pillininaurtua.",
        "translation": "And because I don't know them, though it wouldn't happen, I'd apparently end up doing that."
    },
    "68": {
        "startTime": 387.974,
        "endTime": 396.134,
        "transcript": "Piyuicaaqelliningraata kinguakun nallunriraqluku eyagyarat nalluamki.",
        "translation": "Though they actually wouldn't, I'd find out later because I don't know abstinence practices."
    },
    "69": {
        "startTime": 397.496,
        "endTime": 406.496,
        "transcript": "Kitak' camek imumek elpet arcaqakek'ngarpenek qanruyukarmek qanrutqerkut.",
        "translation": "Now, please tell us of something you think is important, a little piece of traditional wisdom."
    },
    "70": {
        "startTime": 406.508,
        "endTime": 410.558,
        "transcript": "Tua-i-wa arcaqalriit amllerrsaaqellriit.",
        "translation": "Well, there are many important things."
    },
    "71": {
        "startTime": 410.567,
        "endTime": 417.457,
        "transcript": "Yuut tau͡gaam maa-i ilakutenrirluteng-llu pillrat wii assikenritla'qka.",
        "translation": "But I don't like how people today are no longer a community."
    },
    "72": {
        "startTime": 417.597,
        "endTime": 426.877,
        "transcript": "Wangkuta imum' ellangellemteńi ilamta-llu tungayamta-llu, naklekulluteng kenkulluteng yuullruut.",
        "translation": "Back when we were going up, our families and relaties, they lived with compassion and love for each other."
    },
    "73": {
        "startTime": 426.886,
        "endTime": 431.806,
        "transcript": "Tangrrutaqameng-llu tua-i tuar nakmiiqapiar ilakelalriit.",
        "translation": "And when they saw each other, it seemed they were the closest of families."
    },
    "74": {
        "startTime": 431.81,
        "endTime": 435.52,
        "transcript": "Quyaluteng tangrrutellmeggnek.",
        "translation": "They are thankful to see each other."
    },
    "75": {
        "startTime": 435.531,
        "endTime": 440.071,
        "transcript": "Pikangqerrucimegcetun-llu cikirrarluki piaqluki.",
        "translation": "And they would give to them from what they could."
    },
    "76": {
        "startTime": 440.46,
        "endTime": 443.99,
        "transcript": "Maa-i tua-i tuaten ayuqenriqapiartut.",
        "translation": "Now, they're absolutely not like that."
    },
    "77": {
        "startTime": 444.007,
        "endTime": 449.287,
        "transcript": "Ilakengrateki tungayukengramteki-ll' caperrsagulluki.",
        "translation": "Though they're our families and relatives, we hesitate with them."
    },
    "78": {
        "startTime": 449.852,
        "endTime": 453.002,
        "transcript": "Tuaten ayuqenrirluteng.",
        "translation": "They're not [loving] like that anymore."
    },
    "79": {
        "startTime": 454.301,
        "endTime": 463.321,
        "transcript": "Cali wii assikeksaitela'arqa ilameggnek teglegaluteng canek angengraata, angyanek massiinanek-llu.",
        "translation": "I also don't like when they things from their families though they're big, boats and motors."
    },
    "80": {
        "startTime": 463.928,
        "endTime": 469.568,
        "transcript": "Tamana tua-i umyuama assikeksaitelaraa, akitulaata-llu cat.",
        "translation": "In my mind, I don't like that, also because things are expensive."
    },
    "81": {
        "startTime": 469.725,
        "endTime": 474.565,
        "transcript": "Tamakunek teglegiaqata yuut wii umyuarteq'lartua",
        "translation": "When people steal those, I think"
    },
    "82": {
        "startTime": 475.256,
        "endTime": 479.756,
        "transcript": "\"Tuquqataqata-llu,\" wiinga-w' umyuarteq'laama",
        "translation": "\"When they're going to die,\" because I think"
    },
    "83": {
        "startTime": 479.766,
        "endTime": 485.446,
        "transcript": "\"Wii tua-i tuquqataquma cat assiilngillrenka umyuaqeciqngamki.\"",
        "translation": "\"If I'm going to die, I will remember the wrong things I've done.\""
    },
    "84": {
        "startTime": 486.268,
        "endTime": 491.073,
        "transcript": "Tuquqatanrilnge'r'ma-w' tua-i maa-i umyuaqelaamki.",
        "translation": "It's because even if I'm not going to die now, I remember them."
    },
    "85": {
        "startTime": 491.242,
        "endTime": 495.242,
        "transcript": "Ilanka-ll' tuaten pinayukluki umyuarteq'lalrianga.",
        "translation": "I think that those around me might do that."
    },
    "86": {
        "startTime": 495.761,
        "endTime": 505.111,
        "transcript": "Man'a teglegyaraq ilaminek, cali navguiyugluteng ilameng caitnek.",
        "translation": "This stealing from one's family, they also destroy their families' things."
    },
    "87": {
        "startTime": 505.313,
        "endTime": 508.643,
        "transcript": "Tamana cali wii assikeksaitaqa.",
        "translation": "I don't like that either."
    },
    "88": {
        "startTime": 509.144,
        "endTime": 515.084,
        "transcript": "Tuar ilateng cangqerresqumavkenaki assinrituq.",
        "translation": "It's bad that it seems they don't want the families to have anything."
    },
    "89": {
        "startTime": 515.097,
        "endTime": 517.977,
        "transcript": "Wangni-w' assinrilngat'lall' tamana.",
        "translation": "That doesn't seem good to me."
    },
    "90": {
        "startTime": 519.415,
        "endTime": 531.675,
        "transcript": "Nangnermek wani camek, camek tayim paicicugcit ayagyuanun kingunerpenun?",
        "translation": "Lastly, what do want to leave behind with the youth, your descendants?"
    },
    "91": {
        "startTime": 531.688,
        "endTime": 536.848,
        "transcript": "Camek assilriamek paicicugcikut?",
        "translation": "What good thing do you want to leave with us?"
    },
    "92": {
        "startTime": 536.852,
        "endTime": 548.412,
        "transcript": "Tua-i-wa ayagyuat makut allayuurcameng maa-i nakukucugluteng-llu kenkulluteng yuukuneng assiryartuq.",
        "translation": "Becuase these young people have become different and pick on each other, it would be good if they lived treating each other with love."
    },
    "93": {
        "startTime": 548.935,
        "endTime": 553.885,
        "transcript": "Alerquutngulria tua-i kenka una angtatailnguq.",
        "translation": "This love that has nothing greater is a traditional instruction."
    },
    "94": {
        "startTime": 554.168,
        "endTime": 561.288,
        "transcript": "Qaneryarani-ll' uitalaria kenka una ciuqlikacagauluni angtataunani-llu.",
        "translation": "It's in the Bible that love is the very first and there's nothing greater than it."
    },
    "95": {
        "startTime": 561.595,
        "endTime": 570.545,
        "transcript": "Tamana tua-i wii umyuaqelaryaaqaqa waten ilanka kenkulluki yuusqessaaqluki-ll' makut ayagyuat arcaqerluki.",
        "translation": "I remember that when I want my family to treat each other with love like this, especially the youth."
    },
    "96": {
        "startTime": 570.552,
        "endTime": 575.082,
        "transcript": "Eq'ukutevkenaki, assikulluki, kenkulluki.",
        "translation": "Do not scorn each other, treat each other well and with love."
    },
    "97": {
        "startTime": 575.341,
        "endTime": 582.251,
        "transcript": "Man'a-llu aturyullrat, arca tua-i cassuutngunrituq, cakaniutngunrituq.",
        "translation": "And this [alcohol] they want to abuse, do not, it's not for anything, and doesn't improve anything."
    },
    "98": {
        "startTime": 582.262,
        "endTime": 586.712,
        "transcript": "Atuusqumanricaaqluku picurlagmek iqungqerran.",
        "translation": "I don't want it to be used because it ends in misfortune."
    },
    "99": {
        "startTime": 587.839,
        "endTime": 591.889,
        "transcript": "Tua-i camun ayagpek'nani picurlagmuun tau͡gaam.",
        "translation": "It doesn't lead to anywhere but misfortune."
    },
    "100": {
        "startTime": 592.699,
        "endTime": 599.549,
        "transcript": "Nunani aturyung'e'rmegteggu atunritaat iquggliqngan.",
        "translation": "Though they want to use it in villages, they don't because it ends badly."
    },
    "101": {
        "startTime": 600.329,
        "endTime": 608.189,
        "transcript": "Tamana tua-i wii umyuama ayagyuanun makunun umyuaqelaasqumalaryaaqekeka.",
        "translation": "In my mind, I want these young people to remember that."
    },
    "102": {
        "startTime": 608.409,
        "endTime": 614.799,
        "transcript": "Wangkuta-llu pillrunrilengramta ayagyuallemteńi, inerciigatellrungramta tua-i.",
        "translation": "Even though we didn't do it in our youth, even if we were mischievous."
    },
    "103": {
        "startTime": 615.688,
        "endTime": 628.118,
        "transcript": "Tau͡gaam tua-i cat ilait anagulluk' atullrunrilemteki, ilamta-llu cait takaqluki yuullruamta.",
        "translation": "But, it's because we didn't excessively use somethings, and we respected the things of those around us in our lives."
    },
    "104": {
        "startTime": 630.332,
        "endTime": 631.472,
        "transcript": "Ii-i, quyana.",
        "translation": "Okay, thank you."
    },
    "105": {
        "startTime": 631.487,
        "endTime": 632.707,
        "transcript": "Ii-i.",
        "translation": "You're welcome."
    },
    "106": {
        "startTime": 633.391,
        "endTime": 635.061,
        "transcript": "Kitak'-wa tua-i.",
        "translation": "Okay, goodbye."
    },
    "107": {
        "startTime": 635.186,
        "endTime": 637.106,
        "transcript": "Aren, tauna-llam...",
        "translation": "Oh my, that too..."
    }
};